import React from "react";
import { PageContainer } from "./PageContainer";
import { Section } from "./Section";
import { PageHeader } from "./PageHeader";

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * SingleColumnTemplate
 *
 * Purpose
 * - Focused content pages with one central column.
 * - No sidebar or grids; children stack vertically.
 *
 * Layout Rules
 * - Root (PageContainer): centered, tokenized background/text
 * - Section: centers a single column wrapper
 * - Column wrapper: w-full max-w-[800px] (or tokenized equivalent), space-y-6 md:space-y-8
 */
export function SingleColumnTemplate({
  title,
  subtitle,
  actions,
  breadcrumbs,
  variant = 'default',
  containerClassName = "",
  headerClassName = "",
  sectionClassName = "",
  columnClassName = "",
  columnStyle = {},
  children,
  ...props
}) {
  const rootTokens = "text-succession-text-primary overflow-x-hidden bg-succession-bg-secondary min-h-screen";
  const mergedColumnStyle = (() => {
    // Default: 55rem, Wide: 20% wider => 66rem. Allow explicit override via columnStyle.maxWidth
    const defaultMax = '55rem';
    const wideMax = '66rem';
    const variantMax = variant === 'wide' ? wideMax : defaultMax;
    const hasExplicitMax = columnStyle && Object.prototype.hasOwnProperty.call(columnStyle, 'maxWidth');
    return {
      maxWidth: hasExplicitMax ? columnStyle.maxWidth : variantMax,
      ...columnStyle,
    };
  })();

  return (
    <PageContainer className={cx("py-4 px-0", rootTokens, containerClassName)} {...props}>
      <Section className={cx("px-4 flex justify-center", sectionClassName)}>
        <div className={cx("w-full space-y-6 md:space-y-8", columnClassName)} style={mergedColumnStyle}>
          {(title || subtitle || actions) ? (
            <PageHeader title={title} subtitle={subtitle} actions={actions} breadcrumbs={breadcrumbs} className={headerClassName} />
          ) : breadcrumbs ? (
            <div className="mb-6 md:mb-8">{breadcrumbs}</div>
          ) : null}

          {children}
        </div>
      </Section>
    </PageContainer>
  );
}

export default SingleColumnTemplate;


